<template>
    <div class="flex-con xs-pad-lr">
        <div
            class="tooltip is-tooltip-bottom"
            :data-tooltip="tooltip"
        >
            <i
                v-if="!isPartial"
                class="fa fa-money"
                :class="statusClass"
            ></i>
            <div v-else>
                <multi-color-icon
                    icon-class="fa-money"
                    :left-class="baseClass"
                    :right-class="overlayClass"
                >
                </multi-color-icon>
            </div>
        </div>
        <div
            v-if="includeText"
            class="status-text"
        >
            {{tooltip}}
        </div>
    </div>
</template>

<script>
import StatusUtil from '../../util/StatusUtil';
import MultiColorIcon from '../../elements/MultiColoredIcon';

export default {
    name : "Payment",
    components : {
        MultiColorIcon,
    },
    props : {
        status : {
            type : Number,
            required : true,
        },
        refund : {
            type : Number,
            required : false,
        },
        credit : {
            type : Number,
            required : false,
        },
        includeText : {
            type : Boolean,
            required : false,
            default : false,
        },
    },
    computed : {
        statusClass () {
            return `payment-color-${this.status}`;
        },
        tooltip () {
            if(this.isPartial) {
                const text = [];
                if(StatusUtil.PAYMENT_REFUND.PARTIALLY.id === this.refund){
                    text.push('Partially Refunded');
                }
                if(StatusUtil.PAYMENT_REFUND.PARTIALLY.id === this.credit){
                    text.push('Partially Credited');
                }
                return text.join(' & ');
            }
            const status = StatusUtil.PAYMENT.findById(this.status);
            return status ? status.name : 'Unknown';
        },
        isPartial () {
            return StatusUtil.PAYMENT_REFUND.PARTIALLY.id === this.refund || StatusUtil.PAYMENT_REFUND.PARTIALLY.id === this.credit;
        },
        overlayClass () {
            if(StatusUtil.PAYMENT_REFUND.PARTIALLY.id === this.refund){
                return 'payment-color-' + StatusUtil.PAYMENT.REFUNDED.id;
            }
            if(StatusUtil.PAYMENT_REFUND.PARTIALLY.id === this.credit){
                return 'payment-color-' + StatusUtil.PAYMENT.CREDITED.id;
            }
            return 'payment-color-' + StatusUtil.PAYMENT.PAID.id;
        },
        baseClass () {
            if(this.refund > 1 && this.credit > 1) {
                return 'payment-color-' + StatusUtil.PAYMENT.CREDITED.id;
            }
            return 'payment-color-' + StatusUtil.PAYMENT.PAID.id;
        },
    }
}
</script>
